'use client';

import type { ReactNode } from 'react';

import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { useId, useState } from 'react';

/**
 * Expands the sub-category grid. Every tile is rendered on the server (crawlable links); the ones
 * after the first rows are hidden through the `subcategories` group while `data-expanded` is false.
 * Phones scroll through all tiles in one row, so the toggle starts at `md`.
 * The toggle looks like the filter drawer's „Zobraziť viac (+9)“ (Figma 60093:4679): DLZ/Body/S
 * Medium in text/brand, padded to a 44 px target without moving the layout.
 */
export function SubcategoryToggle({
  hiddenCount,
  children,
}: {
  hiddenCount: number;
  children: ReactNode;
}) {
  const { t } = useTranslations();
  const [expanded, setExpanded] = useState(false);
  const id = useId();

  return (
    <div className="flex flex-col items-start gap-4">
      <div id={id} data-expanded={expanded} className="group/subcategories w-full">
        {children}
      </div>
      <button
        type="button"
        aria-expanded={expanded}
        aria-controls={id}
        onClick={() => setExpanded(value => !value)}
        className="dlz-body-s-medium -mx-1 -my-3 rounded-sm px-1 py-3 text-[#D7191F] transition-colors hover:text-[#B5141A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012] max-md:hidden"
      >
        {expanded ? t('text604') : `${t('text338')} (+${hiddenCount})`}
      </button>
    </div>
  );
}
